import React from 'react'
import { Stack } from '@mui/material'
import { NumberField } from 'src/Libs/inputs/formik'
import { UnitTypes } from 'src/Libs/types'

interface Props {
  maxChargeLabel: string
  maxChargeName: string
  limitLabel: string
  limitName: string
  disableLimit?: boolean
  disabledMax?: boolean
}

/**
 * @param maxChargeLabel
 * @param maxChargeName
 * @param limitName
 * @param limitLabel
 * @constructor
 */
const MaxChargeCurrentLimitSet: React.VFC<Props> = ({
  maxChargeLabel,
  maxChargeName,
  limitName,
  limitLabel,
  disableLimit = false,
  disabledMax = false,
}) => {
  return (
    <Stack direction="row" spacing={2}>
      <NumberField name={maxChargeName} label={maxChargeLabel} suffix={UnitTypes.ampere} disabled={disabledMax} />
      <NumberField name={limitName} label={limitLabel} suffix={UnitTypes.ampere} disabled={disableLimit} />
    </Stack>
  )
}

export default MaxChargeCurrentLimitSet
